// @flow
import { Component } from 'react';

import './balance-board.scss';
import './balance-board.responsive.scss';

export class Setting extends Component {}
